export default __webpack_public_path__ + "static/media/udemydata.c4d4bfff.png";